import RowResumeText from '../../../../components/RowResumeText';
import { EMPTY_VALUES, getDateFormat } from '../../../../Apis/functions';
import { gender } from '../../../../enums/genderEnum';
import { useTranslation } from 'react-i18next';
import ResumeInfoCard from '../../../../components/ResumeInfoCard';
import { DocumentLinesIcon, UserDocumentIcon } from '../../../../components/buttons/IconButtons';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param user
 */
const SummaryFieldsUser = ({ user }) => {

    const { t } = useTranslation();

    return (
         <ResumeInfoCard
            title={t('contract')}
            titleIcon={<UserDocumentIcon width={24} height={24} />}
            icon={<DocumentLinesIcon className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='grid-container-resume-data mb-2'>
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('name')} value={user?.name || EMPTY_VALUES.DEFAULT} 
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('last_name')} value={user?.lastName || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('second_last_name')} value={user?.secondLastName || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('document_id')} value={user?.documentId || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                       title={t('email')} value={user?.email || EMPTY_VALUES.DEFAULT} 
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                       title={t('phone_number')} value={user?.phoneNumber || EMPTY_VALUES.DEFAULT} 
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                         title={t('gender')} value={t(gender[user?.genderId]) || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('dob')} value={getDateFormat(user?.dob, false)} 
                    />
                </div>
            }
        />
    );
}

export default SummaryFieldsUser
